import React from 'react';
import { Price as GridKitPrice, PriceProps as GridKitPriceProps } from 'gd-design-library';
import { formatPrice } from '@utils';
import { PriceWithDiscount } from '@services';
import classNames from 'classnames/bind';
import styles from './Price.module.scss';

const CN = 'price-section';
const discountModifier = `${CN}--discount`;

const cx = classNames.bind(styles);

interface CustomPriceProps extends Omit<GridKitPriceProps, 'currentValue' | 'oldValue'> {
  price: PriceWithDiscount;
  className?: string;
}

export const Price: React.FC<CustomPriceProps> = ({ price, className, ...rest }) => {
  if (!price) {
    return null;
  }

  const hasDiscount = price.discountedValue !== undefined && price.discountedValue !== null;

  const currentValue = hasDiscount
    ? (price.discountedValue === 0 ? 'FREE' : formatPrice(price, true))
    : (price.value === 0 ? 'FREE' : formatPrice(price));

  const oldValue = hasDiscount
    && (price.value === 0 ? 'FREE' : formatPrice(price))
    !== currentValue ? (price.value === 0 ? 'FREE' : formatPrice(price))
    : undefined;

  return (
    <GridKitPrice
      currentValue={ currentValue }
      oldValue={ oldValue }
      className={ cx(
        CN,
        { [discountModifier]: !!oldValue || currentValue === 'FREE' },
        className
      ) }
      { ...rest }
    />
  );
};
